import { ValidatorHelper } from "../helpers/ValidatorHelper";
import { TaskService } from "../services/TaskService";
import { TaskTemplateService } from "../services/TaskTemplateService";

export default class TaskTemplateActions {


  async GetAllAsync(Record: any) {
    let response = await new TaskTemplateService().GetAll(null);
    let responses = [response];

    //napravi validacija
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

}
